/**
 * successor-steps-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { IncomingMessage } from "../../general/incoming-message";
import { MessageTag } from "../../message-tag";

/**
 * When the server receives a {@link SuccessorStepsRequest}, it
 * responds with a {@link SuccessorStepsResponse} that enumerates the common
 * transitive predecessors of the algorithm steps named in the original
 * request.
 */
export class SuccessorStepsMessage extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SUCCESSOR_STEPS;

  public successors : number[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/graphs/successor-steps-response.ts